import tsumugi from '../assets/images/tsumugi_1.png'
import tsumugiGallery1 from '../assets/images/tsumugi_2.png'
import tsumugiGallery2 from '../assets/images/tsumugi_3.png'
import tsumugiGallery3 from '../assets/images/tsumugi_4.png'

import mushamaru from '../assets/images/mushamaru_1.png'
import mushamaruGallery1 from '../assets/images/mushamaru_2.png'
import mushamaruGallery2 from '../assets/images/mushamaru_3.png'
import mushamaruGallery3 from '../assets/images/mushamaru_4.png'
class Character {
  constructor(keyName, nameJp, nameEn, fullImage, twitterId, gallery1, gallery2, gallery3, age, birthday, description) {
    ;[
      this.keyName,
      this.nameJp,
      this.nameEn,
      this.fullImage,
      this.twitterId,
      this.gallery1,
      this.gallery2,
      this.gallery3,
      this.age,
      this.birthday,
      this.description
    ] = [keyName, nameJp, nameEn, fullImage, twitterId, gallery1, gallery2, gallery3, age, birthday, description]
  }
}

export const profiles = [
  new Character(
    'tsumugi',
    '天ノ葉 つむぎ',
    'Tumugi Amanoha',
    tsumugi,
    'Ama_tumugi',
    tsumugiGallery1,
    tsumugiGallery2,
    tsumugiGallery3,
    '14歳',
    '07/06',
    `とある神社の家系に生まれた一人娘。好きなこと・新しいものに目がない。
これまで、危ないという理由から「神社の敷地から、1人で出てはいけない」と言われて育ったが、好奇心が抑えられず、親の言いつけを破ってしまう。`
  ),
  new Character(
    'musha',
    '武者丸',
    'Mushamaru',
    mushamaru,
    'musha_maru',
    mushamaruGallery1,
    mushamaruGallery2,
    mushamaruGallery3,
    '?',
    '10/01',
    `封印されていた神獣。これまでつむぎのぬいぐるみとして扱われており、どこにいくにも一緒だった。
今回つむぎが起こした行動に言いたいことはたくさんあるが、なんだかんだ言って放っておけない優しい一面も持つ。`
  )
]
